module.exports = __webpack_public_path__ + "static/img/AppBannerLogo.75b84f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AppBannerLogo.png
// module id = aa1+
// module chunks = 1